import { ArrayMapper } from "../../../../../../harmony/core";
import { MediaEntityToMediaMapper } from "../../../../../features/media/domain/mappers/media.mapper";
import { RecommendedScheduleEntityToRecommendedScheduleMapper } from "../../../../../features/media/domain/mappers/recommended-schedules.mapper";
import {
  ImageMedia,
  VideoMedia,
} from "../../../../../features/media/domain/models/media";
import { GooglePerformanceMaxEntity } from "../../data/entities/google-performance-max.entity";
import { GooglePerformanceMax } from "../models/google-performance-max";

export const mapGooglePerformanceMaxEntityToModel = (
  from: GooglePerformanceMaxEntity,
): GooglePerformanceMax => {
  const mediaMapper = new MediaEntityToMediaMapper();
  const schedulesMapper = new ArrayMapper(
    new RecommendedScheduleEntityToRecommendedScheduleMapper(),
  );

  return new GooglePerformanceMax(
    from.id,
    from.images.map((image) => mediaMapper.map(image)) as ImageMedia[],
    from.logos.map((logo) => mediaMapper.map(logo)) as ImageMedia[],
    from.videos.map((video) => mediaMapper.map(video)) as VideoMedia[],
    from.landingPageUrl,
    from.headlines,
    from.longHeadlines,
    from.descriptions,
    from.recommendedSchedules
      ? schedulesMapper
          .map(from.recommendedSchedules)
          .sort((a, b) => a.startDate.getTime() - b.startDate.getTime())
      : [],
  );
};
